<template> 
   <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div class="modal-header modal-paddings header-manage">
            <slot name="header">
              default header
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              default body
            </slot>
          </div>

          <div class="modal-footer modal-paddings">
            <slot name="footer">
              <button class="btn btn btn-orange ml-auto" @click="$emit('close')">
                Close
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'modal'
}
</script>
<style lang="scss">
.modal.fade.show {
  display: block
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 10px 5px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  
}
.lgMsg{
    .modal-container {
      width: 50%;
    }
  }
.sm{
    .modal-container {
      width: 40%;
    }
  }
.lg{
    .modal-container {
      width: 60%;
    }
  }
  .modal-header,.modal-footer {
        // padding: 0;
        border: none
  }

  .modal-paddings {
        padding: 0;
  }
  .header-manage {
    padding-bottom: 10px;
    margin: 10px 0px 10px 15px;
    border-bottom: solid rgb(218, 217, 217) 1.2px;
        
  }
.modal-header h3 {
  margin-top: 0;
  padding: 0;
  color: #444;
  font-size: 20px;
}

.modal-body {
  margin:0 0 15px 0 ;

}
.lg .modal-body{
    height: calc(100vh - 150px);
    overflow: auto;
}
.sm .modal-body{
    height: 50%;
    overflow: auto;
}
.lgMsg .modal-body{
    height: 40%;
    overflow: auto;
}
.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>



// WEBPACK FOOTER //
// src/components/common/modal.vue